import React from "react";
import CRUDAdmin from "../../components/admin/CRUDAdmin";

export default function Customers() {
  return (
    <CRUDAdmin
      title="Customers"
      subtitle="Patrons converted from leads or added manually."
      endpoint="/admin/customers"
      testIdPrefix="cust"
      defaults={{}}
      columns={[
        { title: "Name", render: r => <div className="serif text-lg">{r.name}</div> },
        { title: "Phone", key: "phone" },
        { title: "Email", key: "email" },
        { title: "City", key: "city" },
      ]}
      fields={[
        { name: "name", label: "Name" },
        { name: "phone", label: "Phone" },
        { name: "email", label: "Email" },
        { name: "company", label: "Company / Family" },
        { name: "city", label: "City" },
        { name: "address", label: "Address", type: "textarea", full: true },
        { name: "gstin", label: "GSTIN" },
        { name: "notes", label: "Notes", type: "textarea", full: true },
      ]}
    />
  );
}
